import { Rpc } from '../rpc';
import { RpcObservableServer } from '../rpc-observable-server';
import {
    RpcObservablePerformanceError, RpcObservablePerformanceKey, RpcObservablePerformanceRequest, RpcObservablePerformanceResult
} from './rpc-observable-performance-model';

export class RpcObservablePerformanceServer
    extends RpcObservableServer<RpcObservablePerformanceRequest, RpcObservablePerformanceResult, RpcObservablePerformanceError> {

    /**
     * Initializes a new instance of the RpcObservablePerformanceServer class.
     *
     * @param rpc the rpc object.
     */
    constructor(rpc: Rpc) {
        super(rpc, RpcObservablePerformanceKey.command, RpcObservablePerformanceKey.version);
    }
}
